import { Column, Entity, Index, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IAnnex } from './interface/IAnnex';
import { IVerification } from './interface/IVerification';
import { IBuilding } from './interface/IBuilding';
import { IInstallation } from './interface/IInstallation';

@Entity('annex')
export class Annex extends BaseEntity implements IAnnex {
  apiMapping = {
    id: 'extId',
    title: 'title',
    description: 'description',
    fileName: 'fileName',
    excelFileName: 'excelFileName',
    fileData: {
      type: 'AnnexFile',
      fieldName: 'fileData'
    },
    excelFileData: {
      type: 'AnnexFile',
      fieldName: 'excelFileData'
    },
    isReportIncluded: 'isReportIncluded',
    buildingId: 'buildingId',
    installationId: 'installationId',
    verificationId: 'verificationId'
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: true })
  @Index()
  extId: number;

  @Column({ nullable: true })
  title: string;

  @Column({ nullable: true })
  description: string;

  @Column({ nullable: true })
  fileName: string;

  @Column({ nullable: true, select: false })
  fileData: string;

  @Column({ nullable: true })
  excelFileName: string;

  @Column({ nullable: true, select: false })
  excelFileData: string;

  @Column({ nullable: true })
  isReportIncluded: boolean;

  @Column({ nullable: true })
  buildingId: number;

  @Column({ nullable: true })
  installationId: number;

  @ManyToOne('Verification', 'annexes')
  @JoinColumn()
  verification: IVerification;

  building: IBuilding;
  installation: IInstallation;
}
